/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homefeaturestitle2Inputs */



/**
* | output |
* | --- |
* | "From registration to the conference" |
*
* @param {Homefeaturestitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homefeaturestitle2 = /** @type {((inputs?: Homefeaturestitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homefeaturestitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("From registration to the conference")
	return /** @type {LocalizedString} */ ("Von der Bewerbung bis zur Konferenz")
});
export { homefeaturestitle2 as "homeFeaturesTitle" }